import { FaqItem, Plan } from "./types";

const CORE_FEATURES = [
  "Every feature included",
  "SMS, email, and voice",
  "Unlimited team members",
  "Unlimited contacts",
];

export const PLANS: Plan[] = [
  {
    title: "Starter",
    audience: "For single location studios",
    subtitle: "1,000 message credits a month",
    price: 89,
    interval: "month",
    features: [...CORE_FEATURES, "1 phone number"],
    href: "/signup",
    cta: "Get started",
    pricingMessage: "14 day money-back guarantee",
    featured: false,
  },
  {
    title: "Starter",
    audience: "For single location studios",
    subtitle: "1,000 message credits a month",
    price: 69,
    interval: "year",
    features: [...CORE_FEATURES, "1 phone number"],
    href: "/signup",
    cta: "Get started",
    pricingMessage: "14 day money-back guarantee",
    featured: false,
  },
  {
    title: "Pro",
    audience: "For multi-location and franchises",
    subtitle: "3,000 message credits a month, +$0.035/additional",
    price: 189,
    interval: "month",
    features: [...CORE_FEATURES, "Up to 3 phone numbers"],
    href: "/signup",
    cta: "Get started",
    pricingMessage: "14 day money-back guarantee",
    featured: true,
  },
  {
    title: "Pro",
    audience: "For multi-location and franchises",
    subtitle: "3,000 message credits a month, +$0.035/additional",
    price: 149,
    interval: "year",
    features: [...CORE_FEATURES, "Up to 3 phone numbers"],
    href: "/signup",
    cta: "Get started",
    pricingMessage: "14 day money-back guarantee",
    featured: true,
  },
  {
    title: "Enterprise",
    subtitle: "Volume pricing for high-volume and multi-location brands",
    price: "Custom",
    interval: "month",
    features: [
      "Everything in Pro",
      "Volume-discounted credits",
      "Dedicated support team",
      "White-glove onboarding",
      "Custom phone numbers",
    ],
    href: "/book-a-demo",
    cta: "Book a call",
    pricingMessage: "Custom pricing for high volume",
    featured: false,
  },
  {
    title: "Enterprise",
    subtitle: "Volume pricing for high-volume and multi-location brands",
    price: "Custom",
    interval: "year",
    features: [
      "Everything in Pro",
      "Volume-discounted credits",
      "Dedicated support team",
      "White-glove onboarding",
      "Custom phone numbers",
    ],
    href: "/book-a-demo",
    cta: "Book a call",
    pricingMessage: "Custom pricing for high volume",
    featured: false,
  },
];

export const PRICING_FAQ_ITEMS: FaqItem[] = [
  {
    question: "What's included in each plan?",
    answer:
      "Every plan includes the entire Helios platform: all features, all channels (SMS, MMS, email, and voice), unlimited team members, and unlimited contacts. Plans differ only by how many message credits are included each month and how many phone numbers you get.",
  },
  {
    question: "Do you charge per user or per contact?",
    answer:
      "No. Team members and contacts are unlimited on every plan. You're never billed for the size of your team or your list. You pay for how much you send, never for what you're allowed to use.",
  },
  {
    question: "What is a message credit?",
    answer:
      "It's the unit we bill messaging in. 1 SMS segment = 1 credit, 1 MMS (picture message) = 3 credits, and 10 emails = 1 credit. Voice is included and never uses credits.",
  },
  {
    question: "What is an SMS segment?",
    answer:
      "Carriers send texts in segments. A standard text up to 160 characters is one segment, which is one credit. Longer texts are split into multiple segments, and each additional segment is another credit.",
  },
  {
    question: "Why did my text use more than one credit?",
    answer:
      "Two reasons: it was longer than 160 characters, or it contained an emoji or special character. Emojis and certain symbols switch a text to an encoding that fits only 70 characters per segment instead of 160, so the same-looking message can take more segments.",
  },
  {
    question: "Do emojis really cost more?",
    answer:
      "They can. A single emoji re-encodes the whole text, dropping capacity from 160 to 70 characters per segment. A short text with an emoji can use 2 credits where the plain version used 1. If credits matter for a big send, keep it plain text.",
  },
  {
    question: "How are emails counted?",
    answer:
      "Ten emails use one credit, so each email is a tenth of a credit. That makes email the most economical channel for long-form content and large sends.",
  },
  {
    question: "Does voice cost credits?",
    answer:
      "No. Calls and voicemail are included with the platform and never draw from your credit pool.",
  },
  {
    question: "What happens if I run out of credits?",
    answer:
      "It depends on your plan. On Pro, you keep sending and anything beyond your 3,000 credits bills at $0.035 per credit. On Starter, sending pauses once you've used your 1,000 credits and resumes next cycle, or right away if you upgrade, so there are no surprise charges.",
  },
  {
    question: "Do unused credits roll over?",
    answer:
      "No. Your credit pool refreshes at the start of each billing cycle, and unused credits don't carry over.",
  },
  {
    question: "Is annual cheaper than monthly?",
    answer:
      "Yes. Annual billing works out to $69/mo for Starter and $149/mo for Pro, versus $89 and $189 month to month, saving roughly 20%.",
  },
  {
    question: "Is there a setup fee or contract?",
    answer:
      "No. There are no fees to get started and no long-term contract. Choose monthly or annual, and accounts set up instantly so you can be sending in under a minute.",
  },
  {
    question: "Can I cancel anytime?",
    answer:
      "Yes. You can cancel anytime. You're billed through the end of the current billing period and not after.",
  },
  {
    question: "Will I get a new number, or can I keep mine?",
    answer:
      "Both. We can provision a new local number that matches your area code, or port an existing number you already use.",
  },
  {
    question: "Where can I see the fine print?",
    answer:
      "Our terms, policies, and disclaimers are linked in the footer menu. Email us at hey@sendhelios.com with any additional questions about our policies.",
  },
];
